import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface ICommitReleasedProductsToManufacturingPayload {
    designID: number;
    mItemID: number;
}

async function commitReleasedProductsToManufacturing(
    payload: ICommitReleasedProductsToManufacturingPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/CommitReleasedProductsToManufacturing",
        payload,
    );
    return response.data;
}

export function useCommitReleasedProductsToManufacturing() {
    return useMutation({
        mutationFn: commitReleasedProductsToManufacturing,
    });
}
